import classnames from 'classnames';
import DatePicker from 'components/DatePicker';
import { type FC, useMemo } from 'react';
import useLayout, { LayoutType } from 'utils/layout';
import { millisecondsIn89Days } from 'utils/time';
import { useTranslation } from 'utils/translations';

import styles from './DateRange.module.scss';

type DateRangeProps = {
  dateFrom: Date;
  dateTo: Date;
  handleChangeDateFrom: (date: Date | null) => void;
  handleChangeDateTo: (date: Date | null) => void;
};

const DateRange: FC<DateRangeProps> = ({
  dateFrom,
  dateTo,
  handleChangeDateFrom,
  handleChangeDateTo,
}) => {
  const layout = useLayout();
  const datePickerRangeText = useTranslation(
    'payment_history_select_date_range',
  );
  const titleDateFrom = useTranslation('from');
  const titleDateTo = useTranslation('to');

  const minDateFrom = useMemo(() => {
    const now = new Date();
    const dateToTime = now.setHours(0, 0, 0, 0);

    return new Date(dateToTime - millisecondsIn89Days);
  }, []);

  return (
    <div
      className={classnames(styles['datepicker-range-wrapper'], {
        [styles['datepicker-range-wrapper-desktop']]:
          layout !== LayoutType.mobile,
      })}
    >
      <span
        className={classnames(styles['datepicker-range-title'], {
          [styles['show-on-desktop']]: layout === LayoutType.wide,
        })}
      >
        {datePickerRangeText}
      </span>
      <div
        className={classnames(styles['datepicker-range'], {
          [styles['datepicker-range-desktop']]: layout !== LayoutType.mobile,
        })}
      >
        <DatePicker
          title={titleDateFrom}
          value={dateFrom}
          minDate={minDateFrom}
          maxDate={dateTo}
          handleDateChange={handleChangeDateFrom}
        />
        <DatePicker
          title={titleDateTo}
          value={dateTo}
          minDate={dateFrom}
          handleDateChange={handleChangeDateTo}
        />
      </div>
    </div>
  );
};

export default DateRange;
